import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import RestApiUtils from '../../../apiclient/moebli/RestApiUtils.js'
import EscrowAccountBalancePageUI from './EscrowAccountBalancePageUI.js'
// 733 update modal is handled in the UI component


class EscrowAccountBalancePageSF extends Component {
    constructor(props) {
        super(props)
        this.state = {
            errorList: null,
            esccAccountList: null,
            dsraDipAccList: null,
            emailSendMode: false,
            response: null,
            downloadMode: false,
            showDsraTracker: false,
            showTable: false,
            update733Mode: false,
            adjustmentModalOpen: false,
            adjustmentModalTitle: '',
            adjustmentModalTransactionList: [],
            adjustmentModalTotalAmount: '',
            adjustmentModalViewPageUrl: ''
        }
    }

    render() {
        return (
            <EscrowAccountBalancePageUI
                context={this.props.context}
                errorList={this.state.errorList}
                response={this.state.response}
                esccAccountList={this.state.esccAccountList}
                dsraDipAccList={this.state.dsraDipAccList}
                emailSendMode={this.state.emailSendMode}
                onEmailClick={this.onEmailClick}
                onDSRATrackerEmailClick={this.onDSRATrackerEmailClick}
                onRefreshClick={this.onRefreshClick}
                downloadMode={this.state.downloadMode}
                onDownloadClick={this.onDownloadClick}
                //
                showDsraTracker={this.state.showDsraTracker}
                onShowDsraTrackerClick={() => { this.setState({ showDsraTracker: !this.state.showDsraTracker }) }}
                showTable={this.state.showTable}
                onShowTableClick={() => { this.setState({ showTable: !this.state.showTable }) }}
                onEdit733Click={() => this.setState({ update733Mode: true })}
                update733Mode={this.state.update733Mode}
                onCancel733Click={() => this.setState({ update733Mode: false })}
                onSuccess733Click={() => { this.setState({ update733Mode: false }, this.onRefreshClick) }}
                //
                onFdInterestClick={this.onFdInterestClick}
                onGainOnMutualFundClick={this.onGainOnMutualFundClick}
                onBankChargesClick={this.onBankChargesClick}
                onPennyDropCreditClick={this.onPennyDropCreditClick}
                onWithdrawalClick={this.onWithdrawalClick}
                onFdBalanceClick={this.onFdBalanceClick}
                adjustmentModalOpen={this.state.adjustmentModalOpen}
                adjustmentModalTitle={this.state.adjustmentModalTitle}
                adjustmentModalTransactionList={this.state.adjustmentModalTransactionList}
                adjustmentModalTotalAmount={this.state.adjustmentModalTotalAmount}
                adjustmentModalViewPageUrl={this.state.adjustmentModalViewPageUrl}
                onAdjustmentModalClose={this.onAdjustmentModalClose}
            />
        )
    }

    componentDidMount() {
        let context = this.props.context
        this.getEscrowAccounts(context)
    }

    getEscrowAccounts = (context) => {
        RestApiUtils.get(
            context,
            `/api/su/accounts/escrowAccounts/v2/balances`,
            this.getEscrowAccountsCallback,
            null
        )
    }

    getEscrowAccountsCallback = (response) => {
        let dsraDipAccList = response.esccAccountList.filter(acc => acc.dsraDipF4 !== '0')
        this.setState({
            errorList: response.errorList,
            esccAccountList: response.esccAccountList,
            dsraDipAccList: dsraDipAccList,
            response: response
        })
    }


    onEmailClick = () => {
        this.setState({ emailSendMode: true })
        RestApiUtils.post(this.props.context, `/api/su/util/reports/transactions`,
            this.onEmailCallback, {})
    }

    onEmailCallback = (response) => {
        this.setState({ emailSendMode: false })
    }
    onDSRATrackerEmailClick = () => {
        this.setState({ emailSendMode: true })
        RestApiUtils.post(this.props.context, `/api/su/util/reports/dsraDipped`,
            this.onDSRATrackerEmailClickCallback, {})
    }

    onDSRATrackerEmailClickCallback = (response) => {
        this.setState({ emailSendMode: false })
    }

    onDownloadClick = () => {
        this.setState({ downloadMode: true });

        RestApiUtils.get(
            this.props.context,
            `/api/su/accounts/escrowAccounts/excel/fileDownloadSignedUrl`, // Updated endpoint
            this.onDownloadClickCallback,
            null,
            null
        );
    }

    onDownloadClickCallback = (response) => {
        this.setState({ downloadMode: false, errorList: response.errorList });
        if (response.errorList.length === 0) {
            const link = document.createElement('a');
            link.href = response.signedUrl.signedUrl; // Assuming this is the correct structure
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        }
    }

    onRefreshClick = () => {
        let context = this.props.context
        this.setState({ esccAccountList: null, errorList: null }, () => {
            this.getEscrowAccounts(this.props.context)
        })
    }

    onFdBalanceClick = () => {
        const transactionList = this.state.response && this.state.response.fdTransactionList ? this.state.response.fdTransactionList : []
        const totalAmount = this.state.response && this.state.response.fdBalance ? this.state.response.fdBalance : '0'
        this.setState({
            adjustmentModalOpen: true,
            adjustmentModalTitle: '(b) FD balance - Transactions',
            adjustmentModalTransactionList: transactionList,
            adjustmentModalTotalAmount: totalAmount,
            adjustmentModalViewPageUrl: '/su/txns/nodal/007105010733/fd'
        })
    }

    onFdInterestClick = () => {
        const transactionList = this.state.response && this.state.response.fdInterestIn733TransactionList ? this.state.response.fdInterestIn733TransactionList : []
        const totalAmount = this.state.response && this.state.response.fdInterestEarned ? this.state.response.fdInterestEarned : '0'
        this.setState({
            adjustmentModalOpen: true,
            adjustmentModalTitle: '(a) Interest on FD booked in 733 - Transactions',
            adjustmentModalTransactionList: transactionList,
            adjustmentModalTotalAmount: totalAmount,
            adjustmentModalViewPageUrl: '/su/txns/nodal/007105010733/fd'
        })
    }

    onGainOnMutualFundClick = () => {
        const transactionList = this.state.response && this.state.response.gainOnMutualFundTransactionList ? this.state.response.gainOnMutualFundTransactionList : []
        const totalAmount = this.state.response && this.state.response.gainOnMutualFund ? this.state.response.gainOnMutualFund : '0'
        this.setState({
            adjustmentModalOpen: true,
            adjustmentModalTitle: '(b) Gain on Mutual Funds - Transactions',
            adjustmentModalTransactionList: transactionList,
            adjustmentModalTotalAmount: totalAmount,
            adjustmentModalViewPageUrl: '/su/txns/nodal/007105010733/mutualFunds'
        })
    }

    onBankChargesClick = () => {
        const transactionList = this.state.response && this.state.response.bankChargesTransactionList ? this.state.response.bankChargesTransactionList : []
        const totalAmount = this.state.response && this.state.response.bankCharges ? this.state.response.bankCharges : '0'
        this.setState({
            adjustmentModalOpen: true,
            adjustmentModalTitle: '(c) Bank Charges - Transactions',
            adjustmentModalTransactionList: transactionList,
            adjustmentModalTotalAmount: totalAmount,
            adjustmentModalViewPageUrl: '/su/txns/nodal/007105010733/external'
        })
    }

    onPennyDropCreditClick = () => {
        const transactionList = this.state.response && this.state.response.pennyDropCreditTransactionList ? this.state.response.pennyDropCreditTransactionList : []
        const totalAmount = this.state.response && this.state.response.pennyDropCredit ? this.state.response.pennyDropCredit : '0'
        this.setState({
            adjustmentModalOpen: true,
            adjustmentModalTitle: '(d) Penny drop credit - Transactions',
            adjustmentModalTransactionList: transactionList,
            adjustmentModalTotalAmount: totalAmount,
            adjustmentModalViewPageUrl: '/su/txns/nodal/007105010733/external'
        })
    }

    onWithdrawalClick = () => {
        const transactionList = this.state.response && this.state.response.withdrawalTransactionList ? this.state.response.withdrawalTransactionList : []
        const totalAmount = this.state.response && this.state.response.netInterestWithdrawal ? this.state.response.netInterestWithdrawal : '0'
        this.setState({
            adjustmentModalOpen: true,
            adjustmentModalTitle: '(e) Withdrawal - Transactions',
            adjustmentModalTransactionList: transactionList,
            adjustmentModalTotalAmount: totalAmount,
            adjustmentModalViewPageUrl: '/su/txns/nodal/007105010733'
        })
    }

    onAdjustmentModalClose = () => {
        this.setState({
            adjustmentModalOpen: false,
            adjustmentModalTitle: '',
            adjustmentModalTransactionList: [],
            adjustmentModalTotalAmount: '',
            adjustmentModalViewPageUrl: ''
        })
    }

}

export default withRouter(EscrowAccountBalancePageSF)